import React, { useState, useEffect, useContext, useRef } from 'react';
import { courseListOfStudent, totalMovingClassPrice, getCoursePrice, changeCourse, newFetchTeacherByCourseId, changeLevel } from '../../../../../Api/apiUtils';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { Badge, Button, DescriptionList, Field, Table, TextInput } from '../../../../../ui';
import { Actions, Callout, Dialog, FormGrid } from '../ui-pending';
import './changeCourse.scss';
import { ConfigContext, PaymentConfigContext, } from '../../../../../Api/global/ApiContext';
import { toast } from 'react-toastify';
import Select, { SingleValue, components, ControlProps } from 'react-select';
import FindTeacher from '../findTeacher';
import { MixpanelEvents,trackEvent } from '../../../../../utils/mixpanelTracking';
interface Course {
  classesCount: number;
  purchasedLevel: string | null;
  courseName: string;
  courseId: string;
}

interface GroupedCourse {
  courseId: string;
  courseName: string;
  levels: { purchasedLevel: string | null; classesCount: number }[];
}

interface PaymentCourse {
  name: string;
  paidCourseId: string;
  demoCourseId: string;
  levels: {
    name: string;
    classsize: string;
    levelId: string;
  }[];
}

interface TotalMovingClassPriceResponse {
  totalClassPrice: number;
}

interface CourseChangeProps {
  studentId?: string;
}

const ChangeLevel: React.FC<any> = ({ studentId, profileData, courseData, studentUserId }) => {

  console.log("course", profileData)
  const [courses, setCourses] = useState<Course[]>([]);
  const [groupedCourses, setGroupedCourses] = useState<GroupedCourse[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<{ value: string; label: string } | null>(null);
  const [selectedLevels, setSelectedLevels] = useState<{ [key: string]: number | '' }>({});
  const [checkedLevels, setCheckedLevels] = useState<{ [key: string]: boolean }>({});
  const [amount, setAmount] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [paymentCourses, setPaymentCourses] = useState<PaymentCourse[]>([]);
  const [selectedPaymentCourse, setSelectedPaymentCourse] = useState<{ value: string; label: string } | null>(null);
  const [selectedPaymentLevels, setSelectedPaymentLevels] = useState<{ [key: string]: number | '' }>({});
  const [showPaymentFields, setShowPaymentFields] = useState<boolean>(false);
  const [toCourseDetail, setToCourseDetail] = useState<any>(null);
  const [inputsDisabled, setInputsDisabled] = useState<boolean>(false);
  const [teachers, setTeachers] = useState<any[]>([]);
  const [selectedTeacher, setSelectedTeacher] = useState<any>("");
  const [selectedLevelId, setSelectedLevelId] = useState<string | null>(null);
  const [isFreeClass, setIsFreeClass] = useState<boolean | null>(null);
  const [showFreeClassSelection, setShowFreeClassSelection] = useState<boolean>(false);
  const [findTeacherModal, setFindTeacherModal]= useState<boolean>(false);
  const Userdetails = JSON.parse(localStorage.getItem("profileData") || "{}");

  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  // Menu state for all Select components
  const [courseMenuIsOpen, setCourseMenuIsOpen] = useState<boolean>(false);
  const [teacherMenuIsOpen, setTeacherMenuIsOpen] = useState<boolean>(false);

  // Custom Control component to ensure entire control area opens dropdown on click
  const CustomControl = (props: ControlProps<any, false>) => {
    const { innerProps, selectProps } = props;
    const menuIsOpen = selectProps.menuIsOpen;
    const onMenuOpen = selectProps.onMenuOpen;
    
    return (
      <components.Control
        {...props}
        innerProps={{
          ...innerProps,
          onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => {
            if (!menuIsOpen && onMenuOpen) {
              e.preventDefault();
              e.stopPropagation();
              onMenuOpen();
            } else if (innerProps.onMouseDown) {
              innerProps.onMouseDown(e as any);
            }
          },
          onClick: (e: React.MouseEvent<HTMLDivElement>) => {
            if (!menuIsOpen && onMenuOpen) {
              e.preventDefault();
              e.stopPropagation();
              onMenuOpen();
            } else if (innerProps.onClick) {
              innerProps.onClick(e as any);
            }
          }
        }}
      />
    );
  };

  const CustomOption = (props: any) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="cc-teacher-option"
      >
        <span>{data.label.split(' - ')[0]}</span>
        <span className="cc-teacher-option__meta ds-text-subtle">
          {data.workingStatus}
        </span>
      </div>
    );
  };

  const paymentConfig = useContext(PaymentConfigContext);
  const paymentcourse = paymentConfig?.onlineCourseAcademic2 || [];

  useEffect(() => {
    const fetchCourses = async () => {
      if (!studentId) return;

      try {
        const response = await courseListOfStudent(studentId);
        setCourses(response);
        setLoading(false);
      } catch (error) {
        toast.error('Failed to fetch course list.');
        setLoading(false);
      }
    };

    fetchCourses();
  }, [studentId]);

  useEffect(() => {
    if (!selectedPaymentCourse) return;

    const fetchTeachers = async () => {
      setLoading(true);
      try {
        const courseId = selectedPaymentCourse?.value;
        const payload = {
          page: 0,
          size: 500,
          courseId: courseId,
        };
        const response = await newFetchTeacherByCourseId(payload);
        if (response.data && Array.isArray(response.data.content)) {
          setTeachers(response.data.content);
        } else {
          toast.error("Unexpected API response format.");
          setTeachers([]);
        }
      } catch (error) {
        console.error("Error fetching teachers:", error);
        toast.error("Failed to fetch teachers. Please try again.");
        setTeachers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, [selectedPaymentCourse]);

  // Handle outside clicks to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const isClickInsideSelect = target.closest('.react-select-container') || 
                                   target.closest('[class*="react-select"]') ||
                                   target.closest('[id*="react-select"]') ||
                                   target.closest('[class*="css-"]');
      
      if (!isClickInsideSelect) {
        setCourseMenuIsOpen(false);
        setTeacherMenuIsOpen(false);
      }
    };

    if (courseMenuIsOpen || teacherMenuIsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [courseMenuIsOpen, teacherMenuIsOpen]);

  useEffect(() => {
    if (courses.length > 0) {
      const grouped = courses.reduce((acc, course) => {
        const existingCourse = acc.find(c => c.courseId === course.courseId);
        if (existingCourse) {
          existingCourse.levels.push({
            purchasedLevel: course.purchasedLevel,
            classesCount: course.classesCount,
          });
        } else {
          acc.push({
            courseId: course.courseId,
            courseName: course.courseName,
            levels: [{ purchasedLevel: course.purchasedLevel, classesCount: course.classesCount }],
          });
        }
        return acc;
      }, [] as GroupedCourse[]);
      setGroupedCourses(grouped);
    }
  }, [courses]);

  useEffect(() => {
    if (selectedCourse) {
      const course = groupedCourses.find(c => c.courseId === selectedCourse.value);
      if (course) {
        const initialLevels = course.levels.reduce((acc, level) => {
          acc[level.purchasedLevel || 'default'] = level.classesCount;
          return acc;
        }, {} as { [key: string]: number | '' });
        setSelectedLevels(initialLevels);
        
        // Automatically set the payment course to match the selected student course
        const matchingPaymentCourse = paymentCourses.find(c => c.paidCourseId === selectedCourse.value);
        if (matchingPaymentCourse) {
          const paymentCourseOption = {
            value: matchingPaymentCourse.paidCourseId,
            label: matchingPaymentCourse.name
          };
          setSelectedPaymentCourse(paymentCourseOption);
          
          // Initialize the payment course details
          initializePaymentCourseDetails(matchingPaymentCourse);
        }
      }
    }
  }, [selectedCourse, groupedCourses, paymentCourses]);

  const initializePaymentCourseDetails = async (matchingPaymentCourse: PaymentCourse) => {
    let toCousreDetails = matchingPaymentCourse;
    if (toCousreDetails) {
      let levelIds = ([] as any);
      const courseList = (toCousreDetails?.levels || []).map((lev: any) => {
        levelIds.push(lev.levelId);
        return {
          courseId: toCousreDetails.paidCourseId?.toString(),
          levelId: lev.levelId.toString(),
          courseName: toCousreDetails.name,
          level: lev.name,
          classesToPurchase: 0,
          classCount: lev.classsize.toString()
        };
      });
      
      let priceCCObj = (paymentConfig?.timezoneWithCountryName && paymentConfig?.timezoneWithCountryName[profileData.timezone]);
      
      // Add null check for priceCCObj
      if (!priceCCObj) {
        console.error('Price configuration not found for timezone');
        return;
      }
  
      const priceDetails = await getCoursePrice(levelIds.map(Number), priceCCObj.code, priceCCObj.country.toLowerCase());
      let mergedData;
      if (courseList.length && priceDetails && priceDetails.data) {
        mergedData = courseList.map((course: any) => {
          const levelId = course.levelId.toString();
          const priceInfo = priceDetails.data.find((price: any) => price.levelId === Number(levelId));
          return {
            ...course,
            unit_price: priceInfo ? priceInfo.price : null,
            priceWithoutGST: priceInfo && priceInfo.currency == 'INR' ? (priceInfo.price / 1.18).toString() : priceInfo.price.toString(),
            priceWithoutGSTRound: priceInfo && priceInfo.currency == 'INR' ? +((priceInfo.price / 1.18).toFixed(2)) : +(priceInfo.price.toFixed(2)),
            gst: priceInfo && priceInfo.currency == 'INR' ? 1.18 : 0,
            currency: priceInfo ? priceInfo.currency : null,
          };
        });
      }
  
      // Check if mergedData exists and has at least one item
      if (!mergedData || mergedData.length === 0) {
        console.error('No valid course data available');
        setToCourseDetail(null);
        return;
      }
  
      let toCourseObj = {} as any;
      toCourseObj.levelList = mergedData;
      toCourseObj.currency = mergedData[0].currency || 'USD'; // Provide default currency
      toCourseObj.discountPercentage = 0;
      toCourseObj.discountedTotal = 0;
      toCourseObj.totalPrice = 0;
      setToCourseDetail(calculateTotalPrice(toCourseObj));
      console.log("toCoursedetails", toCourseDetail);
    } else {
      setToCourseDetail(null);
    }
  };
  useEffect(() => {
    if (paymentcourse.length > 0) {
      setPaymentCourses(paymentcourse);
    }
  }, [paymentcourse]);

  // Cleanup debounce timer on component unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleCourseChange = (selectedOption: { value: string; label: string } | null) => {
    setSelectedCourse(selectedOption);
    setSelectedPaymentCourse(null);
    setToCourseDetail(null);
    setSelectedTeacher("");
  };

  const handleLevelCheckboxChange = (level: string | null) => {
    setCheckedLevels(prev => ({
      ...prev,
      [level || 'default']: !prev[level || 'default']
    }));
  };

  const handleLevelChange = (level: string | null, value: string) => {
    const numericValue = value === '' ? '' : parseInt(value, 10);
    const course = groupedCourses.find(c => c.courseId === selectedCourse?.value);
    if (course) {
      const levelData = course.levels.find(l => l.purchasedLevel === level);
      if (
        levelData &&
        (numericValue === '' || (numericValue <= levelData.classesCount && numericValue >= 0))
      ) {
        setSelectedLevels((prev) => ({
          ...prev,
          [level || 'default']: numericValue,
        }));
      } else {
        toast.error(`Class count cannot exceed ${levelData?.classesCount}.`);
      }
    }
  };

  const handleChangeCourseSubmit = async () => {
    // Clear any existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Prevent multiple rapid clicks
    if (loading) {
      return;
    }

    // Set a debounce timer to prevent double clicks
    debounceTimerRef.current = setTimeout(async () => {
      setLoading(true);
      if (!selectedCourse || !selectedPaymentCourse || !studentId || !toCourseDetail) {
        toast.error('Please select both from and to courses and ensure studentId is provided.');
        setLoading(false);
        return;
      }

    // Filter only checked levels for fromCourseLevels
    const fromCourseLevels = Object.entries(selectedLevels)
      .filter(([level, classesCount]) => 
        checkedLevels[level] && classesCount !== '' && classesCount !== 0
      )
      .map(([level, classesCount]) => ({
        level: level === 'default' ? null : level,
        courseName: groupedCourses.find(c => c.courseId === selectedCourse.value)?.courseName || "",
        noOfClasses: classesCount as number,
      }));

    const toCourseLevels = toCourseDetail.levelList
      .filter((level: any) => level.classCount !== '' && level.classCount !== 0)
      .map((level: any) => {
        const discount = +((+level.unit_price * +level.classCount * toCourseDetail.discountPercentage) / 100).toFixed(2);
        let finalAmount = +((+level.unit_price * +level.classCount) - +discount).toFixed(2);
        let amountExcludeGST = +(finalAmount / 1.18).toFixed(2);
        let gstAmount = (+finalAmount - amountExcludeGST).toFixed(2);
        return {
          returnlevel: level.level,
          noOfClasses: +level.classCount,
          courseName: level.courseName,
          totalFinalPrice: finalAmount,
          totalGstAmount: level.currency == "INR" ? gstAmount : 0,
          totalDiscount: discount,
          unit_price: level.unit_price
        };
      });

    const totalMovedClasses = toCourseLevels.reduce((sum: any, level: any) => sum + level.noOfClasses, 0);
    if (!selectedLevelId) {
      toast.error('Please select a level');
      setLoading(false);
      return;
    }
   
       const totalRemovedClasses = fromCourseLevels.reduce((sum: any, level: any) => sum + level.noOfClasses, 0);
       if (!selectedLevelId) {
        toast.error('Please select a level');
        setLoading(false);
        return;
      }
  
      if (!selectedTeacher.value) {
        toast.error('Please select teacher');
        setLoading(false);
        return;
      }
    const payload = {
      studentId,
      teacherId: (selectedTeacher as any).value,
      prefix: "CL",
      isFreeClass: isFreeClass,
      adminUser: Userdetails?.firstName,
      studentName: profileData.firstName,
      totalMovedClasses,
      totalRemovedClasses,
      walletAmount: Math.max(0, Math.round(+(amount || 0) - +toCourseDetail.discountedTotal)),

            fromCourse: {
        courseId: selectedCourse.value,
        removeLevels: fromCourseLevels,
      },
      toCourse: {
        courseId: selectedPaymentCourse.value,
        addLevels: toCourseLevels,
      }
    };
    if (amount !== 0 && Math.round(+(amount || 0) - +toCourseDetail.discountedTotal) < 0) {
      toast.error('Existing Course Amount should not be greater than New Course Amount');
      setLoading(false);
      return;
    }
    try {
      const response = await changeCourse(payload);
      if (response) {
        try {
          const changeLevelPayload = {
            userId: profileData.userId, // or profileData.userId if available
            courseId: selectedPaymentCourse.value,
            levelId: selectedLevelId, // Use the selected levelId
            // reason: "course change", // You can customize this
            changeType: "level",
            // previousCourseId: selectedCourse.value
          };

          
          const levelChangeResponse = await changeLevel(changeLevelPayload);
          if (levelChangeResponse) {
            toast.success('Course and level changed successfully!');
    
            
            
                                  trackEvent(MixpanelEvents.LEVEL_CHANGE, {
                                    page:"Course Change in student profile",
                                    courseId: selectedPaymentCourse.value,
                                    levelId: selectedLevelId, 
                                    previousCourseId: selectedCourse.value,
                                    totalMovedClasses: totalMovedClasses,
                                    totalRemovedClasses:  totalRemovedClasses,
                                    studentId:studentId,
                                    userId: profileData.userId, 
            
                             
                               
                                  });
            
            setLoading(false);
          } else {
            toast.success('Course changed successfully, but level change failed!');
          }
        } catch (levelError) {
          console.error('Error changing level:', levelError);
          toast.success('Course changed successfully, but level change failed!');
        }

        // Reset form fields
        setSelectedCourse(null);
        setSelectedPaymentCourse(null);
        setSelectedLevels({});
        setShowFreeClassSelection(false);
        setSelectedPaymentLevels({});
        setShowPaymentFields(false);
        setAmount(null);
        setSelectedLevelId(null); // Reset selected level
        setToCourseDetail(null);
      } else {
        toast.error('Failed to change course.');
      }
    } catch (error) {
      toast.error('Failed to change course.');
      console.error('Error changing course:', error);
    } finally {
      setLoading(false); // Stop loading in all cases
    }
    }, 1000); // 1000ms debounce delay
  };

  const handleSubmit = async () => {
    if (!selectedCourse || !studentId) {
      toast.error('Please select a course and ensure studentId is provided.');
      return;
    }

    // Check if at least one level is selected
    const hasSelectedLevel = Object.entries(checkedLevels).some(([_, isChecked]) => isChecked);
    if (!hasSelectedLevel) {
      toast.error('Please select at least one level');
      return;
    }

    // Check if selected levels have valid class counts
    const hasValidClassCounts = Object.entries(selectedLevels).some(
      ([level, count]) => checkedLevels[level] && count !== '' && count !== 0
    );
    if (!hasValidClassCounts) {
      toast.error('Please enter valid class counts for selected levels');
      return;
    }
  
    const payload = Object.entries(selectedLevels)
      .filter(([level, _]) => checkedLevels[level]) // Only include checked levels
      .map(([level, classesCount]) => ({
        studentId,
        courseId: selectedCourse.value,
        noOfClasses: classesCount === '' ? 0 : classesCount,
        level: level === 'default' ? null : level,
      }));
  
    try {
      const response = await totalMovingClassPrice(payload.filter(a => a.noOfClasses));
      
      if (response.status !== 200) {
        const errorMessage = response.data;
        toast.error(errorMessage);
        return;
      }
  
      const data = response.data as TotalMovingClassPriceResponse;
      setAmount(data.totalClassPrice);
      
      // Show free class selection if amount is 0
      if (data.totalClassPrice === 0) {
        setShowFreeClassSelection(true);
      } else {
        setInputsDisabled(true);
        setShowPaymentFields(true);
      }
      
    } catch (error: any) {
      let errorMessage = 'Failed to submit course change';
      
      if (error.response) {
        errorMessage = error.response.data?.message || 
                     JSON.stringify(error.response.data) ||
                     error.response.statusText ||
                     `Request failed with status ${error.response.status}`;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
      console.error('API Error:', error.response?.data || error);
    }
  };

  const handleFreeClassSelection = async (value: boolean) => {
    setIsFreeClass(value);
    if (value) {
      // If free class is selected, set all prices to 0
      if (toCourseDetail) {
        const updatedToCourseDetail = {
          ...toCourseDetail,
          levelList: toCourseDetail.levelList.map((level: any) => ({
            ...level,
            unit_price: 0,
            priceWithoutGST: 0,
            priceWithoutGSTRound: 0,
            classCount: level.classCount // Preserve the class count
          })),
          total: 0,
          discountedTotal: 0,
          currency: toCourseDetail.currency // Preserve the currency
        };
        setToCourseDetail(updatedToCourseDetail);
      }
    } else {
      // If free class is not selected, restore original prices
      if (toCourseDetail) {
        const course = paymentCourses.find(c => c.paidCourseId === selectedCourse?.value);
        if (course) {
          const levelIds = course.levels.map((lev: any) => lev.levelId);
          const priceCCObj = (paymentConfig?.timezoneWithCountryName && paymentConfig?.timezoneWithCountryName[profileData.timezone]);
          
          try {
            const priceDetails = await getCoursePrice(levelIds.map(Number), priceCCObj.code, priceCCObj.country.toLowerCase());
            if (priceDetails && priceDetails.data) {
              const courseList = course.levels.map((lev: any) => {
                const priceInfo = priceDetails.data.find((price: any) => price.levelId === Number(lev.levelId));
                return {
                  courseId: course.paidCourseId?.toString(),
                  levelId: lev.levelId.toString(),
                  courseName: course.name,
                  level: lev.name,
                  classesToPurchase: 0,
                  classCount: lev.classsize.toString(),
                  unit_price: priceInfo ? priceInfo.price : null,
                  priceWithoutGST: priceInfo && priceInfo.currency == 'INR' ? (priceInfo.price / 1.18).toString() : priceInfo.price.toString(),
                  priceWithoutGSTRound: priceInfo && priceInfo.currency == 'INR' ? +((priceInfo.price / 1.18).toFixed(2)) : +(priceInfo.price.toFixed(2)),
                  gst: priceInfo && priceInfo.currency == 'INR' ? 1.18 : 0,
                  currency: priceInfo ? priceInfo.currency : null,
                };
              });

              const updatedToCourseDetail = {
                levelList: courseList,
                currency: courseList[0].currency,
                discountPercentage: 0,
                discountedTotal: 0,
                total: 0
              };
              setToCourseDetail(calculateTotalPrice(updatedToCourseDetail));
            }
          } catch (error) {
            console.error('Error fetching prices:', error);
            toast.error('Failed to restore original prices');
          }
        }
      }
    }
    setInputsDisabled(true);
    setShowPaymentFields(true);
  };

  const handleReset = () => {
    setIsFreeClass(null);
    setCheckedLevels({});
    setInputsDisabled(false);
    setSelectedPaymentCourse(null);
    setShowFreeClassSelection(false);
    setSelectedPaymentLevels({});
    setShowPaymentFields(false);
    setAmount(null);
    setToCourseDetail(null);
    setSelectedCourse(null);
    setSelectedLevels({});
  };

  const handleClassCount = (level: any, value: string | number) => {
    let sanitizedValue = typeof value === "string"
      ? value.replace(/[^0-9]/g, '')
      : value;
    const newLevelList = toCourseDetail.levelList.map((l: any, i: number) => {
      if (l.levelId === level.levelId) {
        return {
          ...l,
          classCount: +sanitizedValue,
        };
      }
      return l;
    });

    const newToCourseDetail = {
      ...toCourseDetail,
      levelList: newLevelList,
    };

    setToCourseDetail(calculateTotalPrice(newToCourseDetail));

  };

  const handleDiscountChange = (type: string, value: string | number) => {
    let sanitizedValue: string | number = typeof value === "string"
      ? value.replace(/[^0-9]/g, '')
      : value;

    const numericValue = typeof sanitizedValue === "string"
      ? sanitizedValue === '' ? 0 : parseInt(sanitizedValue, 10)
      : sanitizedValue;

    const clampedValue = Math.min(Math.max(numericValue, 0), 100);

    const newToCourseDetail = {
      ...toCourseDetail,
      [type]: +clampedValue,
    };

    setToCourseDetail(calculateTotalPrice(newToCourseDetail));
  };

  const calculateTotalPrice = (toCourseData: any) => {
    let plan = JSON.parse(JSON.stringify(toCourseData));
    let levelList = plan.levelList;

    plan.classCount = levelList.reduce((acc: any, level: any) => acc + +level.classCount, 0);
    plan.total = Math.max(+levelList.reduce((acc: any, level: any) => acc + +(level.classCount * level.unit_price).toFixed(2), 0), 0);
    plan.discountedTotal = Math.max(+(plan.total - (plan.total * +((plan.discountPercentage) / 100))).toFixed(2), 0);
    plan.discountedTotalwithFlash = Math.max(+(plan.total - (plan.total * +((plan.discountPercentage + plan.specialDiscountPercentage + plan.additionalDiscountPercentage + plan.flashDiscountPercentage) / 100))).toFixed(2), 0);
    return plan;
  }

  // if (loading) {
  //   return <p>Loading courses...</p>;
  // }

  return (
    <>
      <Form className="ds-stack">
        <Field label="Select student course">
          {(ctl) => (
            <Select
              isDisabled={inputsDisabled}
              id="courseSelect"
              inputId={ctl.id}
              value={selectedCourse}
              onChange={(newValue) => {
                handleCourseChange(newValue);
                setCourseMenuIsOpen(false);
              }}
              options={groupedCourses.map(course => ({ value: course.courseId, label: course.courseName }))}
              placeholder="Select a course"
              menuIsOpen={courseMenuIsOpen}
              onMenuOpen={() => setCourseMenuIsOpen(true)}
              onMenuClose={() => setCourseMenuIsOpen(false)}
              components={{ Control: CustomControl }}
            />
          )}
        </Field>

        {selectedCourse && (
          <>
            <div className="ds-stack">
              {groupedCourses
                .find(c => c.courseId === selectedCourse.value)
                ?.levels.map((level, index) => (
                  <div key={index} className="cc-level-row">
                    <FormGroup check className="cc-level-row__check">
                      <Input
                        type="checkbox"
                        id={`level-checkbox-${level.purchasedLevel}`}
                        checked={checkedLevels[level.purchasedLevel || 'default'] || false}
                        onChange={() => handleLevelCheckboxChange(level.purchasedLevel)}
                        className='levelChk'
                        disabled={inputsDisabled}
                      />
                      <Label check for={`level-checkbox-${level.purchasedLevel}`}>Include</Label>
                    </FormGroup>
                    <Field
                      className="cc-level-row__field"
                      id={`level-${level.purchasedLevel}`}
                      label={`${level.purchasedLevel || 'No Level'} - Class Count`}
                    >
                      {(ctl) => (
                        <TextInput
                          {...ctl}
                          type="number"
                          value={selectedLevels[level.purchasedLevel || 'default']}
                          onChange={(e) =>
                            handleLevelChange(level.purchasedLevel, e.target.value)
                          }
                          min={0}
                          max={
                            groupedCourses
                              .find(c => c.courseId === selectedCourse.value)
                              ?.levels.find(l => l.purchasedLevel === level.purchasedLevel)?.classesCount
                          }
                          disabled={inputsDisabled || !checkedLevels[level.purchasedLevel || 'default']}
                        />
                      )}
                    </Field>
                  </div>
                ))}

              {amount !== null && (
                <Field id="totalAmount" label="Total Amount">
                  {(ctl) => (
                    <TextInput
                      {...ctl}
                      disabled
                      type="text"
                      value={amount.toFixed(2)}
                      readOnly
                    />
                  )}
                </Field>
              )}
            </div>

            <Actions align="start">
              <Button variant="secondary" onClick={handleSubmit}>Get Class Amount</Button>
              <Button variant="ghost" onClick={handleReset}>Reset</Button>
            </Actions>
          </>
        )}

        {showFreeClassSelection && (
          <fieldset>
            <legend className="ds-field__label">Please confirm: is this a free class?</legend>
            <FormGroup check>
              <Label check>
                <Input
                  isDisabled={inputsDisabled}
                  className="levelChk"
                  type="radio"
                  name="freeClass"
                  checked={isFreeClass === true}
                  onChange={() => handleFreeClassSelection(true)}
                />{' '}
                Yes
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  isDisabled={inputsDisabled}
                  className="levelChk"
                  type="radio"
                  name="freeClass"
                  checked={isFreeClass === false}
                  onChange={() => handleFreeClassSelection(false)}
                />{' '}
                No
              </Label>
            </FormGroup>
          </fieldset>
        )}

        {showPaymentFields && selectedCourse && (
          <>
            <FormGrid>
              <Field id="paymentCourseSelect" label="Selected course">
                {(ctl) => (
                  <TextInput
                    {...ctl}
                    type="text"
                    value={selectedCourse?.label || ''}
                    disabled
                  />
                )}
              </Field>

              <Field label="Select the teacher">
                {(ctl) => (
                  <Select
                    id="paymentTeacherSelect"
                    inputId={ctl.id}
                    value={selectedTeacher}
                    onChange={(selectedOption: any) => {
                      setSelectedTeacher(selectedOption);
                      setTeacherMenuIsOpen(false);
                    }}
                    options={teachers
                      .filter(teacher => teacher.workingStatus === "ACTIVE")
                      .map(teacher => ({
                        value: teacher.teacherId,
                        label: `${teacher.teacherName} - ${teacher.workingStatus}`,
                        workingStatus: teacher.workingStatus
                      }))
                    }
                    placeholder="Select a teacher"
                    components={{ Option: CustomOption, Control: CustomControl }}
                    menuIsOpen={teacherMenuIsOpen}
                    onMenuOpen={() => setTeacherMenuIsOpen(true)}
                    onMenuClose={() => setTeacherMenuIsOpen(false)}
                  />
                )}
              </Field>
            </FormGrid>

            <div className="cc-or">
              <span className="ds-text-muted">or</span>
              <Button variant="secondary" size="sm" onClick={() => setFindTeacherModal(true)}>
                Find Teacher
              </Button>
            </div>

            {toCourseDetail && (
              <>
                <Table caption="New level pricing" className="cc-pricing">
                  <thead>
                    <tr>
                      <th>Active Level</th>
                      <th>Class Count</th>
                      <th>Class Price</th>
                      <th>Discount (%)</th>
                      <th className="cc-pricing__detail">
                        Price Detail ({toCourseDetail.currency})
                        {isFreeClass && <> <Badge tone="success">Free class</Badge></>}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="cc-pricing__levels">
                          {toCourseDetail.levelList.map((level: any, index: number) => (
                            <div key={index} className="cc-pricing__level">
                              <span>{level.level}</span>
                              <Input
                                type="radio"
                                name="selectedLevel"
                                aria-label={`Select ${level.level}`}
                                value={level.levelId}
                                checked={selectedLevelId === level.levelId}
                                onChange={() => setSelectedLevelId(level.levelId)}
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <div className="cc-pricing__levels">
                          {toCourseDetail.levelList.map((level: any, index: number) => (
                            <div key={index} className="cc-pricing__level">
                              <span>{level.level}</span>
                              <TextInput
                                size="sm"
                                className="cc-pricing__input"
                                aria-label={`${level.level} class count`}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={level.classCount}
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  handleClassCount(level, newValue);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <div className="cc-pricing__levels">
                          {toCourseDetail.levelList.map((level: any, index: number) => (
                            <div key={index} className="cc-pricing__level">
                              <span className="cc-pricing__spacer" aria-hidden="true">{level.level}</span>
                              <TextInput
                                size="sm"
                                className="cc-pricing__input"
                                aria-label={`${level.level} class price`}
                                type="text"
                                disabled={true}
                                value={isFreeClass ? 0 : level.unit_price}
                                inputMode="numeric"
                                pattern="[0-9]*"
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <TextInput
                          size="sm"
                          className="cc-pricing__input"
                          aria-label="Discount percentage"
                          type="number"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={isFreeClass ? 0 : toCourseDetail.discountPercentage}
                          onChange={(e) => handleDiscountChange('discountPercentage', Number(e.target.value))}
                          disabled={isFreeClass === true}
                        />
                      </td>
                      <td className="cc-pricing__detail">
                        <div className="cc-pricing__summary">
                          <DescriptionList
                            items={[
                              { label: 'Existing course total', value: <span className="ds-num">{amount?.toFixed(2)} {toCourseDetail.currency}</span> },
                              { label: 'New course total', value: <span className="ds-num">{isFreeClass ? 0 : Math.round(Number(toCourseDetail.discountedTotal))} {toCourseDetail.currency}</span> },
                            ]}
                          />
                          {!showFreeClassSelection && toCourseDetail.discountedTotal > +(amount || 0) ? (
                            <Callout tone="danger">
                              Existing course amount should not exceed than new course amount
                            </Callout>
                          ) : (
                            ( !showFreeClassSelection && +(amount || 0) - (isFreeClass ? 0 : toCourseDetail.discountedTotal)) ? (
                              <Callout tone="info">
                                Balance amount {(+(amount || 0) - (isFreeClass ? 0 : toCourseDetail.discountedTotal)).toFixed(2)} {toCourseDetail.currency} will be add in student wallet.
                              </Callout>
                            ) : ""
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <Actions>
                  <Button
                    variant="primary"
                    loading={loading}
                    onClick={handleChangeCourseSubmit}
                  >
                    {loading ? 'Processing...' : 'Change Level'}
                  </Button>
                </Actions>
              </>
            )}
          </>
        )}
      </Form>

      <Dialog isOpen={findTeacherModal} onClose={() => setFindTeacherModal(false)} title="Find Teacher" size="xl" className="find-teacher-dialog">
        <FindTeacher
          studentId={studentId}
          profileData={profileData}
          preselectedCourseId={selectedCourse?.value}
          onTeacherSelect={(teacher) => {
            setSelectedTeacher({
              value: teacher.teacherId,
              label: `${teacher.firstName} ${teacher.lastName}`,
              // workingStatus: teacher.workingStatus || '',
              // allocationPriority: teacher.allocationPriority || ''
            });
            setFindTeacherModal(false);
          }}
          disableCourseSelect={true}
        />
      </Dialog>
    </>
  );
};

export default ChangeLevel;